export default require('./Link.vue').default